import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMergeServerList, addMergeServer, updateMergeServerLog, getFilterServerList } from '@/api/gmtool/packageCode';
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      paramsData: {
        id: '',
        time: '',
        merge_time: '',
        prediction_time: '',
        end_merge_time: '',
        // content_Val: [],
        template_type: 0,
        areaId: '',
        server_range: [],
        merge_server_range: '',
        mail_notify: 0 // title: [],
        // content: [],
        // is_default: [],
        // language: [],

      },
      dialogShow: false,
      isTemplate: 0,
      mergeServerList: [],
      currentRangeList: [],
      serverIdList: [],
      serverRangList: [],
      rules: {
        areaId: [{
          required: true,
          message: this.$t('pleaseSelectMergeServer'),
          trigger: "blur"
        }],
        time: [{
          required: true,
          message: this.$t('pleaseSelectSpecifyTime'),
          trigger: "blur"
        }],
        merge_time: [{
          required: true,
          message: this.$t('pleaseSelectMergeServerTime'),
          trigger: "blur"
        }],
        prediction_time: [{
          required: true,
          message: this.$t('pleaseSelectPreviewStartTime'),
          trigger: "blur"
        }],
        end_merge_time: [{
          required: true,
          message: this.$t('pleaseSelectMergeServerEndTime'),
          trigger: "blur"
        }],
        content_Val: [{
          required: true,
          message: this.$t('pleaseAddContent'),
          trigger: "blur"
        }],
        is_default: [{
          required: true,
          message: this.$t('pleaseSelectIsTemplate'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseSelectLanguage'),
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseInputTitle'),
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseInputEmailContent'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var serverRangeArr, _data$server_range$sp, _data$server_range$sp2, min, max, i, d;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data) {
                  _context.next = 12;
                  break;
                }

                data = JSON.parse(JSON.stringify(data));
                console.log("data==", data);
                data.areaId = Number(data.areaId);
                serverRangeArr = [];

                if (data.server_range && typeof data.server_range === 'string') {
                  if (data.server_range.includes('-')) {
                    _data$server_range$sp = data.server_range.split('-').map(Number), _data$server_range$sp2 = _slicedToArray(_data$server_range$sp, 2), min = _data$server_range$sp2[0], max = _data$server_range$sp2[1];

                    for (i = min; i <= max; i++) {
                      serverRangeArr.push(i);
                    }
                  } else {
                    serverRangeArr.push(Number(data.server_range));
                  }
                } // this.isTemplate = data.content_Val[0].is_default


                d = {
                  id: data.id,
                  time: data.time,
                  merge_time: data.merge_time,
                  prediction_time: data.prediction_time,
                  end_merge_time: data.end_merge_time,
                  // content_Val: data.content_Val,
                  template_type: data.template_type ? Number(data.template_type) : 0,
                  areaId: data.areaId,
                  merge_server_range: data.merge_server_range,
                  server_range: serverRangeArr,
                  mail_notify: data.mail_notify // title: [],
                  // content: [],
                  // is_default: [],
                  // language: [],

                };
                _this.paramsData = _objectSpread({}, d);
                _context.next = 10;
                return _this.handleTimeChange();

              case 10:
                _this.serverAreaRange = data.merge_server_range || '';

                _this.handleTimeChange().then(function () {
                  _this.handleAreaChange(_this.paramsData.areaId);

                  if (_this.serverAreaRange) {
                    getFilterServerList({
                      is_prod: _this.prod.is_prod,
                      server_range: _this.serverAreaRange
                    }).then(function (res) {
                      if (res.status == 200) {
                        _this.serverRangList = res.data;
                        _this.serverAreaRange = '';
                      }
                    });
                  }
                });

              case 12:
                _this.dialogShow = true;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    addtag: function addtag(data, index) {
      this.paramsData.content_Val[index].content = "".concat(this.paramsData.content_Val[index].content).concat(data);
    },
    isTemplateChange: function isTemplateChange(e) {
      if (e == 0 && this.paramsData.template_type == 1) {
        this.paramsData.content_Val = [];
      }

      this.paramsData.template_type = 0;
    },
    templateTypeChange: function templateTypeChange(e) {
      var _this2 = this;

      this.paramsData.content_Val = [];
      var list = [];

      if (e == 1) {
        list = this.compensationList;
      } else if (e == 2) {
        list = this.awardDistribution;
      }

      list.forEach(function (i) {
        _this2.paramsData.content_Val.push({
          disabled: true,
          content: i.content,
          language: i.value,
          title: i.title,
          is_default: '1'
        });
      });
    },
    addContent: function addContent() {
      this.paramsData.content_Val.push({
        disabled: false,
        content: '',
        language: '',
        title: '',
        is_default: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.paramsData.content_Val.indexOf(item);

      if (index !== -1) {
        this.paramsData.content_Val.splice(index, 1);
      }
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: '',
        time: '',
        merge_time: '',
        prediction_time: '',
        end_merge_time: '',
        content_Val: [],
        template_type: 0,
        areaId: '',
        server_range: [],
        merge_server_range: '',
        mail_notify: 0,
        title: [],
        content: [],
        is_default: [],
        language: []
      };
      this.currentRangeList = [];
      this.$refs.ruleForm.clearValidate();
    },
    handleTimeChange: function handleTimeChange() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.paramsData.time) {
          getMergeServerList({
            time: _this3.paramsData.time,
            is_prod: _this3.prod.is_prod
          }).then(function (res) {
            if (res.status == 200) {
              _this3.mergeServerList = res.data;
              resolve(res.data); // 【关键】通知外部：数据好了！
            } else {
              resolve([]);
            }
          }).catch(function (err) {
            reject(err);
          });
        } else {
          resolve([]);
        }
      });
    },
    handleAreaChange: function handleAreaChange(masterId) {
      this.paramsData.rangeValue = '';
      this.currentRangeList = []; // 根据选中的 master_id 找到对应的 range 数据

      var selectedItem = this.mergeServerList.find(function (item) {
        return item.master_id == masterId;
      });

      if (selectedItem && selectedItem.range) {
        this.currentRangeList = selectedItem.range;
      }
    },
    formatRangeLabel: function formatRangeLabel(range) {
      // 处理 min 大于 max 的情况
      var min = Math.min(range.min, range.max);
      var max = Math.max(range.min, range.max);

      if (min === max) {
        return "".concat(min);
      }

      return "".concat(min, "-").concat(max);
    },
    getRange: function getRange(val) {
      var _this4 = this;

      if (val) {
        getFilterServerList({
          is_prod: this.prod.is_prod,
          server_range: val
        }).then(function (res) {
          if (res.status == 200) {
            _this4.serverRangList = res.data;
          }
        });
      }
    },
    handleServerChange: function handleServerChange(selectedVal) {
      if (!selectedVal || selectedVal.length < 2) return;
      var minId = Math.min.apply(Math, _toConsumableArray(selectedVal));
      var maxId = Math.max.apply(Math, _toConsumableArray(selectedVal));
      var autoSelectedIds = this.serverRangList.map(function (item) {
        return item.serverID;
      }).filter(function (id) {
        return id >= minId && id <= maxId;
      });
      this.paramsData.server_range = autoSelectedIds;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this5 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this5.paramsData)); // data.content_Val.forEach(item => {
          //   data.title.push(item.title)
          //   data.is_default.push(this.isTemplate)
          //   data.language.push(item.language)
          //   data.content.push(item.content)
          // })

          if (Array.isArray(data.server_range) && data.server_range.length > 0) {
            var min = Math.min.apply(Math, _toConsumableArray(data.server_range));
            var max = Math.max.apply(Math, _toConsumableArray(data.server_range));

            if (min === max) {
              data.server_range = "".concat(min); // 如果只选了一个，传 "3"
            } else {
              data.server_range = "".concat(min, "-").concat(max); // 选了多个，传 "3-5"
            }
          } else {
            data.server_range = '';
          }

          data.is_prod = _this5.prod.is_prod;
          delete data.content_Val;
          delete data.rangeValues;
          var reqFn = _this5.paramsData.id ? updateMergeServerLog : addMergeServer;
          reqFn(data).then(function (res) {
            if (res.status == 200) {
              _this5.$message({
                message: _this5.$t('operationSuccess'),
                type: 'success'
              });

              _this5.dialogShow = false;

              _this5.$emit('update');
            }
          });
        }
      });
    }
  }
};